const config = {
  siteName: process.env.SITE_NAME,
  siteUrl: process.env.SITE_URL,
  emailTrackingStartDate: new Date('2024-09-12T00:00:00.000Z'),
  specialOfferForHistoricMembers: {
    endAt: new Date('2025-11-14T23:59:59.000Z'),
    couponIds: {
      plus_monthly_59: 'EARLYADOPTERSPLUSMONTHLY_30',
      plus_yearly_599: 'EARLYADOPTERSPLUSYEARLY_300',
      vip_monthly_139: 'EARLYADOPTERSVIPMONTHLY_80',
      vip_yearly_1399: 'EARLYADOPTERSVIPYEARLY_800',
      ultim_monthly_329: 'EARLYADOPTERSULTIMMONTHLY_190',
      ultim_yearly_3299: 'EARLYADOPTERSULTIMYEARLY_1900',
    },
  },
};

export default config;
